import TrackingBase, { TrackingTypes } from "./tracking-base";

/**
 * @class
 * @classdesc Tracking class for Google Analytics
 *
 * @param {Object} hcs - HCS instance
 */
export default class GoogleAnalytics extends TrackingBase
{
    constructor(paramObj) {
        super(paramObj);
    }

    _pushData(trackingType, data) {
        // Remap toolbar events to other events (tracking types):
        // "Add to Basket" --> Shop
        // "CADBox, drawing" --> Output
        switch(trackingType) {
            case TrackingTypes.Toolbar:
                switch(data.optionId) {
                    case "AR":
                    case "Overview Pdf":
                    case "Download File":
                    case "CadBox":
                    case "Dimensional Drawing":
                    case "Dimensional Drawing Cuttings":
                    case "Parts List":
                    case "Share Configuration":
                    case "Exploded View":
                    case "Exploded View Pdf":
                        trackingType = TrackingTypes.Output;
                        break;

                    case "Add to Basket":
                        // Log using the "Shop" event type.
                        break;
                }
                break;
        }

        let tData = {
            event: "HCS." + trackingType
        };

        if(data.length) {
            // Convert array to single object.
            // Possible duplicates will not be resolved, the latest value will remain.
            data.forEach(item => {
                Object.assign(tData, item);
            });
        } else {
            Object.assign(tData, data);
        }

        let resultData = {};

        // Remove null values.
        Object.keys(tData).forEach(key => {
            if(tData[key]) {
                resultData[key] = tData[key];
            }
        });

        window.cadclick.debug.console.debug("Google Analytics", resultData);

        // Push data to Google Analytics data layer.
        // Create fallback of data layer is not available.
        (window.dataLayer || []).push(tData);
    }
}